import styled from "styled-components";

const List = styled.div`
  display: grid;
  gap: 1px;
  background: #EEEEEE;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  overflow: hidden;
`;

export default List;